module.exports = __webpack_public_path__ + "static/media/delivery.902efcfd.jpg";